import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const TONE = {
  neutral: 'bg-secondary text-secondary-foreground',
  action: 'bg-accent text-accent-foreground',
  brand: 'bg-brand/10 text-brand',
  good: 'bg-good-soft text-good',
  warn: 'bg-warn-soft text-warn',
  bad: 'bg-bad-soft text-bad'
} as const;

/** Nhãn trạng thái: chữ tối thiểu 12px (không dùng cỡ tuỳ ý 9–11px). */
export default function Pill({ tone = 'neutral', children, className }: { tone?: keyof typeof TONE; children: ReactNode; className?: string }) {
  return <span className={cn('inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium leading-4', TONE[tone], className)}>{children}</span>;
}
